import { PulseStorage, StorageChangeKeyMatch, StorageChangeOrigin } from '@pulse/common';
import { Subject } from 'rxjs';
import { PulseEnvironment } from '../../globals';

export class PulseBroadcastChannel<T = any> {
    messages = new Subject<T | null>();
    private nativeChannel?: BroadcastChannel;
    private channelName: string;

    constructor(
        channel: string,
        private persistentStorage: PulseStorage,
        private env: PulseEnvironment,
    ) {
        this.channelName = `pulse_bc_${channel}`;
        this.init();
    }

    postMessage(message: T): void {
        if (this.nativeChannel) {
            this.nativeChannel.postMessage(message);
        } else {
            this.persistentStorage.setJSON(this.channelName, message);
        }
    }

    private init(): void {
        if (this.env.win.BroadcastChannel) {
            this.nativeChannel = new this.env.win.BroadcastChannel(this.channelName);
            this.nativeChannel.addEventListener('message', (m) => {
                this.messages.next(m.data);
            });

            return;
        }

        this.persistentStorage
            .change(this.channelName, StorageChangeKeyMatch.Full, StorageChangeOrigin.External)
            .subscribe((change) => {
                const value = JSON.parse(change.value || 'null');
                this.messages.next(value);
            });
    }
}
